var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
var icons = {
    info: "data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/info-circle%3C/title%3E%3Cpath fill='XXXXX' d='M11.9485 2.05135C9.21419 -0.682914 4.78253 -0.682695 2.05045 2.04938C-0.685671 4.7854 -0.681953 9.21323 2.05242 11.9475C4.78472 14.6798 9.21441 14.6855 11.9504 11.9495C14.6826 9.21727 14.6807 4.78365 11.9485 2.05135ZM7.04692 2.60906C7.77645 2.60906 8.36828 3.20077 8.36828 3.93031C8.36828 4.66038 7.77645 5.25177 7.04692 5.25177C6.31706 5.25177 5.72578 4.66027 5.72578 3.93031C5.72578 3.20066 6.31706 2.60906 7.04692 2.60906ZM9.24919 10.0965C9.24919 10.0965 8.44222 11.4178 6.49655 11.4178C5.76658 11.4178 5.28522 10.8261 5.28522 10.0965L5.95875 7.10885C5.97335 7.05381 5.97665 6.99637 5.96845 6.94002C5.96024 6.88367 5.9407 6.82956 5.91101 6.78096C5.88131 6.73237 5.84208 6.6903 5.79568 6.65728C5.74927 6.62427 5.69666 6.601 5.64102 6.58888L5.06505 6.46288V6.13202H7.75895C7.97989 6.13202 8.13914 6.34312 8.07888 6.55607L7.29258 9.76623C7.29258 10.0975 7.53638 10.2563 7.86811 10.2563C8.75241 10.2563 9.24919 9.65609 9.24919 9.65609V10.0965Z' fill-rule='evenodd'/%3E%3C/svg%3E",
};
var getIcon = function (icon, size, fill, hoverFill, activeFill) {
    var encodeFill = function (fillString) { return fillString.replace('#', '%23'); };
    var dataUriDefault = icon.replace('XXXXX', encodeFill(fill));
    var dataUriHover = icon.replace('XXXXX', encodeFill(hoverFill));
    var dataUriActive = icon.replace('XXXXX', encodeFill(activeFill));
    return {
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUriDefault, "\") !important"),
        width: size,
        height: size,
        '&:hover': {
            backgroundImage: "url(\"".concat(dataUriHover, "\") !important"),
        },
        '&:active': {
            backgroundImage: "url(\"".concat(dataUriActive, "\") !important"),
        },
        ':focus, :focus-visible': {
            boxShadow: '0 0 0 2px #ffffff, 0 0 0 4px #347abe',
            borderRadius: 999,
            outline: 'none',
        },
    };
};
export var actions = {
    display: 'block',
    height: 40,
    padding: 0,
    float: 'right',
    fontSize: 0,
    marginTop: (4 + 2) * -1,
    marginRight: 8 * -1,
};
export var actionButton = {
    display: 'inline-block',
    borderLeft: '1px solid #8A959E',
    marginLeft: '0px !important',
    marginRight: 0,
    fontSize: 'auto',
    height: 40,
    width: 40,
    color: '#000000',
    ':hover': {
        borderLeft: '1px solid #8A959E',
        color: '#a6a6a6',
    },
    ':focus': {
        borderLeft: '1px solid #8A959E',
        color: '#a6a6a6',
    },
};
export var actionButtonLeft = {
    borderRight: '1px solid #8A959E',
    marginRight: '0px',
    marginLeft: 0,
    fontSize: 14,
    height: 40,
    width: 40,
    color: '#000000',
    ':hover': {
        borderRight: '1px solid #8A959E',
        color: '#a6a6a6',
    },
    ':focus': {
        borderRight: '1px solid #8A959E',
        color: '#a6a6a6',
    },
};
export var actionButtonIcon = {
    color: '#000000',
    fontSize: 14,
    left: 1,
    ':hover': {
        color: '#a6a6a6',
    },
};
export var actionsLeft = {
    float: 'left',
    marginLeft: 8 * -1,
    marginRight: 8,
};
export var buttonBorderNone = {
    borderLeft: 'none',
    borderRight: 'none',
};
export var error = {
    border: "2px solid ".concat('#CC0821'),
    ':focus': {
        border: "2px solid ".concat('#CC0821'),
    },
};
export var disabled = {
    backgroundColor: '#DFE4E8',
    border: '2px solid #AEB6BD',
    color: '#8E9AA3',
    cursor: 'not-allowed',
    '::placeholder': {
        color: '#8a959e',
    },
};
export var footnote = __assign(__assign({}, reset), { color: '#323E48', display: 'block', fontSize: 12, fontWeight: 600, lineHeight: '150%', marginTop: 8, paddingLeft: '2px' });
export var disabledFootnote = __assign(__assign({}, footnote), { color: '#8E9AA3' });
export var errorMessage = __assign(__assign({}, footnote), { marginTop: 0, color: '#B80018' });
export var focus = {
    border: "2px solid ".concat('#2B66D6'),
    padding: '18px 11px',
    boxShadow: 'none',
    button: {
        height: 36,
        ':hover': {
            height: 36,
        },
    },
};
export var infoIcon = __assign(__assign({}, getIcon(icons.info, 14, '#1454CC', '#003FB8', '#2B66D6')), { marginLeft: 8, marginTop: -2, verticalAlign: 'middle' });
export var input = __assign(__assign({}, reset), { color: '#000000', backgroundColor: '#ffffff', border: '1px solid #8A959E', borderRadius: 8, boxSizing: 'border-box', display: 'block', fontSize: 16, fontWeight: 500, outline: 'none', padding: '19px 12px', position: 'relative', transition: 'box-shadow 0.3s ease-in-out', width: '100%', height: 32, '::placeholder': {
        color: '#42505C',
    }, disabled: disabled, '[disabled]': disabled, ':focus': focus });
export var value = {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    lineHeight: '20px',
    boxSizing: 'border-box',
    display: 'block',
    margin: 0,
    padding: 0,
    outline: 'none',
    width: '100%',
    verticalAlign: 'top',
};
export var valueWrapper = {
    overflow: 'hidden',
    flex: 1,
};
export var responsive = (_a = {},
    _a["@media ".concat(mobile(700))] = {
        fontSize: 18,
        height: 48,
        padding: "11px ".concat(8, "px"),
    },
    _a);
export var responsiveInputValue = (_b = {},
    _b["@media ".concat(mobile(700))] = {
        lineHeight: 24,
    },
    _b);
export var disabledLabel = {
    color: '#8E9AA3',
    'span span, a span': __assign(__assign({}, infoIcon), getIcon(icons.info, 14, '#8E9AA3', '#8E9AA3', '#8E9AA3')),
    '& + input + span': {
        color: '#8E9AA3',
    },
    '& + textarea + span': {
        color: '#8E9AA3',
    },
};
export var label = __assign(__assign({}, reset), { color: '#323E48', display: 'block', fontSize: 14, fontWeight: 600, lineHeight: '18px', paddingLeft: '2px', width: '100%', em: {
        fontStyle: 'italic',
        textTransform: 'lowercase',
        paddingLeft: '2px',
        paddingRight: '2px',
    }, '& i': {
        color: '#0D69D4',
        width: 14,
        height: 14,
        marginLeft: 4,
        '&:hover': {
            color: '#003FB8',
        },
        '&:active': {
            color: '#2B66D6',
        },
    } });
export var labelSide = __assign(__assign({}, label), { marginTop: 6 });
export var labelWrapperChildren = {
    marginTop: 0,
    marginBottom: 0,
    paddingLeft: 0,
};
export var labelWrapChildren = {
    display: 'inline-flex',
    flexDirection: 'column',
    width: '100%',
    button: {
        minHeight: 'unset',
    },
};
export var labelWrapChildrenSide = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};
var labelWrapSpan = __assign(__assign({}, label), { whiteSpace: 'nowrap', width: 'unset' });
export var labelContentSpanLeft = __assign(__assign({}, labelWrapSpan), { paddingRight: '12px !important' });
export var labelContentSpanRight = __assign(__assign({}, labelWrapSpan), { paddingLeft: '12px !important' });
export var labelContentSpanTop = __assign(__assign({}, labelWrapSpan), { paddingLeft: 2, paddingBottom: 8 });
export var validationLabel = {
    marginLeft: 4,
};
